
import { AudioPlayerManager } from '../../audioPlayer/audioPlayerManager';
import { AudioPlayerStates, ICaptionsItem } from '../../../types/common';
import { IPlayerProvider, IPlayerProviderHandler } from './playerProvider';
import { getAudioPlayerState } from '../../../store/general/selectors';
import { getState } from '../../../store';

export class AudioPlayerProvider implements IPlayerProviderHandler {

  public async play(time?: number) {
    await AudioPlayerManager.getInstance().play(time)
  }

  public async seek(time?: number) {
    await AudioPlayerManager.getInstance().seek(time);
  }

  public async getCurrentTime(): Promise<number> {
    return AudioPlayerManager.getInstance().getCurrentTime();
  }

  public async pause() {
    await AudioPlayerManager.getInstance().pause();
  }

  public getTargetCaptions(): ICaptionsItem[] {
    return AudioPlayerManager.getInstance().getCaptions();
  }

  public async getActiveTargetCaptionIndex(): Promise<number> {
    const playerManager = AudioPlayerManager.getInstance();
    const currentTime = playerManager.getCurrentTime();
    const {captionIndex} = playerManager.getActiveResult(currentTime);
    return captionIndex;
  }

  public isPaused(): boolean {
    return !AudioPlayerManager.getInstance().isPlayerActive();
  }

  public isPlay(): boolean {
    const state = getAudioPlayerState(getState());
    return state === AudioPlayerStates.PLAYING;
  }
}
